import { array, literal, struct } from 'io-ts/Decoder';

import { DimensionLine } from '../scale/DimensionLine';

/**
 * Sent when the measurement lines are changed
 */
export const ChangeDimensionLine = struct({
	type: literal('change-dimension-line'),
	dimensionLines: array(DimensionLine),
});
